import { useGlobalGtmListeners } from '@ps/googleTagManager';

export default function GlobalGtmRegistrations() {
  useGlobalGtmListeners();
  return null;
}
